export enum AppPage {
  TripAdvisor = 'page_trip_advisor',
  PrimeHome = 'page_prime_home',
  ImmigrationHome = 'page_immigration_home',
  TourHome = 'page_tour_home',
  Profile = 'page_profile',
  Activity = 'page_activity',
  Explore = 'page_explore',
  Notification = 'page_notification',
  MainHome = 'page_main_home',
}
